import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  subtitle: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: 0,
    textAlign: 'center',
  },
}));

export default function SubTitle({ subtitle }) {
  const classes = useStyles();

  return (
    <Typography variant="subtitle2" className={classes.subtitle}>
      {subtitle}
    </Typography>
  );
}
